import { SHIP_ART, type ShipArt } from './art.ts';

/**
 * Attribution for the `source` artwork layer, if it ever needs one (null = none); nothing else
 * needs to change.
 */
export const SOURCE_ART_CREDIT: string | null = null;

/** Credit lines to show for the artwork currently in use. */
export function artCredits(art: ShipArt = SHIP_ART): string[] {
  return art === 'source' && SOURCE_ART_CREDIT ? [SOURCE_ART_CREDIT] : [];
}
